module.exports = __webpack_public_path__ + "static/media/kc2.8358edb1.png";